import { filtersHelper } from '@/utils';
import { locationModel } from '@/models/api/location.model';
import { panelTypeModel } from '@/models/api/panelType.model';

export const panelModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    phoneCode: data.phone_code,
    phone: data.phone,
    email: data.email,
    address: data.address,
    mapLink: data.map_link,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    location: data.location ? locationModel(data.location) : null,
    panelType: data.panel_type ? panelTypeModel(data.panel_type) : null
});